"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import BezierEasing from 'bezier-easing';
import { Box } from '../Box/Box.web.js';

var _excluded = ["name", "id", "startValue", "endValue", "duration", "decimals", "easing", "tag"];
var defaultEasing = BezierEasing(0.5, 0, 0, 1);
var AnimatedCounter = function AnimatedCounter(_ref) {
  var name = _ref.name,
    id = _ref.id,
    _ref$startValue = _ref.startValue,
    startValue = _ref$startValue === undefined ? 0 : _ref$startValue,
    endValue = _ref.endValue,
    _ref$duration = _ref.duration,
    duration = _ref$duration === undefined ? 1000 : _ref$duration,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === undefined ? 0 : _ref$decimals,
    _ref$easing = _ref.easing,
    easing = _ref$easing === undefined ? 'default' : _ref$easing,
    _ref$tag = _ref.tag,
    tag = _ref$tag === undefined ? 'span' : _ref$tag,
    props = _objectWithoutProperties(_ref, _excluded);
  if (duration <= 0) {
    throw new Error('Duration cannot be 0 or negative');
  }
  var _React$useState = React.useState(startValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var reqAnimFrameRef = React.useRef(-1);
  var startTimeRef = React.useRef(null);
  React.useEffect(function () {
    var easingFn = function easingFn(value) {
      if (easing === 'linear') {
        return value;
      } else {
        return defaultEasing(value);
      }
    };
    var _updateCounter = function updateCounter(timestamp) {
      if (startTimeRef.current === null) {
        startTimeRef.current = timestamp;
      }
      var progress = easingFn(Math.min(1, (timestamp - startTimeRef.current) / duration));
      var transitionedValue = startValue * (1 - progress) + endValue * progress;
      setValue(transitionedValue);
      if (transitionedValue === endValue) {
        cancelAnimationFrame(reqAnimFrameRef.current);
      } else {
        reqAnimFrameRef.current = requestAnimationFrame(_updateCounter);
      }
    };
    startTimeRef.current = null;
    reqAnimFrameRef.current = requestAnimationFrame(_updateCounter);
    return function () {
      return cancelAnimationFrame(reqAnimFrameRef.current);
    };
  }, [startValue, endValue, duration, easing]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "inline-block",
    "data-testid": "elemental-AnimatedCounter-".concat(id || name),
    id: id || name,
    tag: tag
  }, props), value.toFixed(decimals));
};

export { AnimatedCounter };
